// Google Consent Mode v2 (mode avancé) : gtag est toujours chargé, mais sans
// consentement Google ne reçoit que des signaux anonymes sans cookie,
// utilisés pour modéliser le trafic et les conversions des visiteurs qui refusent.
type Gtag = (...args: unknown[]) => void;

const gtag = (...args: unknown[]) => {
  const g = (window as unknown as { gtag?: Gtag }).gtag;
  if (g) g(...args);
};

const sentOnce = new Set<string>();

export const trackPageView = (path: string) => {
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name: string, params: Record<string, unknown> = {}) => {
  gtag("event", name, params);
};

/** Conversion envoyée une seule fois par identifiant (évite les doublons au rechargement). */
export const trackConversion = (
  name: "purchase" | "generate_lead" | "begin_checkout" | "contact",
  params: Record<string, unknown> & { transaction_id?: string } = {},
) => {
  const key = `${name}:${params.transaction_id ?? ""}`;
  if (params.transaction_id) {
    if (sentOnce.has(key) || sessionStorage.getItem(`ga-conv-${key}`)) return;
    sessionStorage.setItem(`ga-conv-${key}`, "1");
  }
  sentOnce.add(key);
  gtag("event", name, { currency: "EUR", ...params });
};
